/**
 * Controls frontend resource authorization enforcement. Production defaults
 * to enabled; acceptance environments may explicitly set it to false.
 */
export const isResourceAuthorizationEnabled =
  process.env.UMI_APP_ENABLE_RESOURCE_GUARD !== 'false';
